import React from 'react';

import { captureException } from '../../sentry';

import { stripXflowParams } from './XflowInit';

interface Props {
  children: React.ReactNode;
}

interface State {
  hasError: boolean;
}

/**
 * Catches errors, stopping them from unmounting the whole app.
 * Sends them to sentry with an xflow:error tag.
 */
export default class XflowErrorBoundary extends React.Component<Props, State> {
  state = {
    hasError: false,
  };

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
    this.setState({ hasError: true });
    captureException(error, {
      componentStack: errorInfo.componentStack,
      xflow: 'error',
    });
    stripXflowParams();
  }

  render() {
    if (this.state.hasError) {
      return null;
    }
    return this.props.children;
  }
}
